module.exports = __webpack_public_path__ + "img/sim-pratica.2300e846.png";